import * as React from 'react'

import { inject, observer } from 'mobx-react'

import { BrandStruxhubIcon } from '~/client/src/shared/components/icons/BrandStruxhubIcon'
import UserProfilePreview from '~/client/src/shared/components/UserProfilePreview/UserProfilePreview'
import { brandName } from '~/client/src/shared/localization/brand'
import ProjectMembersStore from '~/client/src/shared/stores/domain/ProjectMembers.store'

interface IProps {
  userId?: string | null
  projectMembersStore?: ProjectMembersStore
}

@inject('projectMembersStore')
@observer
export default class UserOrBrandCell extends React.Component<IProps> {
  public render() {
    const { userId, projectMembersStore } = this.props

    if (userId) {
      const user = projectMembersStore?.getById(userId)
      if (user) {
        return <UserProfilePreview user={user} />
      }
    }

    return (
      <span className="tw:flex tw:items-center tw:gap-1.5">
        <BrandStruxhubIcon size="md" />
        <span className="tw:text-body-md tw:text-foreground">{brandName}</span>
      </span>
    )
  }
}
